import Button from "@mui/material/Button";
import * as theme from '../../theme';

export default function FileUploadButton(props) {
  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
      <Button variant="contained" component="label" sx={{ }}>{props.label}<input type="file" accept=".pdf" hidden onChange={props.onChange()} /></Button>
    </div>
  );
}